import asserts from '../asserts';

const { isExist } = asserts;

const formatPrice = (number) => {
  if (!isExist(number)) return 0;
  if (`${number}` === '0') return number;
  return Math.ceil(number * 100) / 100;
};

const formatToFixed2 = (number) => {
  if (!isExist(number)) return 0;
  if (`${number}` === '0') return number;
  const roundNumber = Math.round(number * 100) / 100;
  const value = parseFloat(roundNumber).toFixed(2);
  return value;
};

const formatToFixed4 = (number) => {
  if (!isExist(number)) return 0;
  if (`${number}` === '0') return number;
  const roundNumber = Math.round(number * 10000) / 10000;
  const value = parseFloat(roundNumber).toFixed(4);
  return value;
};

export default { formatPrice, formatToFixed2, formatToFixed4 };
